import React, { useState, useEffect, useRef } from 'react';

const SNOOZE_KEY = 'pwa_install_snoozed_until';
const SNOOZE_DAYS = 30;

function isStandalone(): boolean {
  return window.matchMedia('(display-mode: standalone)').matches ||
    (navigator as any).standalone === true;
}
function isSnoozed(): boolean {
  const until = localStorage.getItem(SNOOZE_KEY);
  return !!until && Date.now() < parseInt(until, 10);
}
function snooze() {
  localStorage.setItem(SNOOZE_KEY, String(Date.now() + SNOOZE_DAYS * 24 * 60 * 60 * 1000));
}

export const InstallBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const deferredRef = useRef<any>(null);

  useEffect(() => {
    if (isStandalone() || isSnoozed()) return;

    const handler = (e: Event) => {
      e.preventDefault();
      deferredRef.current = e;
      setDeferredPrompt(e);
      setVisible(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      await deferredPrompt.userChoice;
      setDeferredPrompt(null);
    }
    snooze();
    setVisible(false);
  };

  const handleDismiss = () => {
    snooze();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      left: 0, right: 0,
      bottom: 'calc(64px + var(--safe-bottom) + 8px)',
      zIndex: 200,
      padding: '0 12px',
    }}>
      <div style={{
        background: 'var(--surface)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius)',
        padding: '14px 16px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.14)',
        maxWidth: 460,
        margin: '0 auto',
      }}>
        <p style={{ fontSize: 14, fontWeight: 600, color: 'var(--text)', marginBottom: 6, lineHeight: 1.4 }}>
          📲 Legg til Toolshare på hjemskjermen
        </p>
        <p style={{ fontSize: 14, color: 'var(--text2)', marginBottom: 14, lineHeight: 1.5 }}>
          Få raskere tilgang — fungerer som en vanlig app.
        </p>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button onClick={handleDismiss} style={dismissStyle}>Ikke nå</button>
          <button onClick={handleInstall} style={installStyle}>Ja, legg til</button>
        </div>
      </div>
    </div>
  );
};

const dismissStyle: React.CSSProperties = {
  background: 'none',
  border: '1px solid var(--border-strong)',
  borderRadius: 999,
  padding: '8px 18px',
  fontSize: 14,
  fontWeight: 500,
  color: 'var(--text2)',
  cursor: 'pointer',
};

const installStyle: React.CSSProperties = {
  background: 'var(--green)',
  border: 'none',
  borderRadius: 999,
  padding: '8px 18px',
  fontSize: 14,
  fontWeight: 600,
  color: '#fff',
  cursor: 'pointer',
};
